import { render, staticRenderFns } from "./foodmealdetails.vue?vue&type=template&id=4f380e30"
import script from "./foodmealdetails.vue?vue&type=script&lang=js"
export * from "./foodmealdetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports